<template>
  <div class="right-process-modify">
    <div class="item-container-modify">
      <div
        v-for="(item, index) in processList"
        :key="index"
        class="item-modify"
      >
        <a-tooltip placement="left">
          <template slot="title" v-if="item.notes">
            <div v-for="it in item.notes">
              <div v-if="it">{{ it }} ;</div>
            </div>
          </template>
          <div class="title-modify">
            <a :style="{ 'background-color': item.color }">{{ item.title }}</a>
          </div>
          <div class="content-modify">
            <img class="icon-modify" :src="item.src" />
            <div class="text-modify">
              <div class="datetime-modify">
                {{ item.datetime }}
                <!-- {{ item.event }} -->
              </div>
              <div class="username-modify">{{ item.username }}</div>
            </div>
          </div>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
//1隐患上报2申请移交3移交同意4移交拒绝5任务分配
//6申请延期7延期同意8延期拒绝9提交验收10验收通过
//11验收拒绝12就地整改13停业停产整顿14审批不通过

let titles = [
  "隐患上报",
  "申请移交",
  "移交同意",
  "移交拒绝",
  "任务分配",
  "申请延期",
  "延期同意",
  "延期拒绝",
  "整改实施",
  "验收通过",
  "验收拒绝",
  "就地整改",
  "停业停产整顿",
  "审批不通过",
];

let colors = [
  "#72BEFF",
  "#5ADC9C",
  "#72BEFF",
  "#FF7977",
  "#5ADC9C",
  "#FFD75C",
  "#5ADC9C",
  "#FF7977",
  "#72BEFF",
  "#5ADC9C",
  "#FF7977",
  "#FFD75C",
  "#FF7977",
  "#FF7977",
];

let imgs = [
  require("@/assets/images/pro_01report.png"),
  require("@/assets/images/pro_01transfer.png"),
  require("@/assets/images/pro_01transfer_ok.png"),
  require("@/assets/images/pro_01transfer_un.png"),
  require("@/assets/images/pro_02distribute.png"),
  require("@/assets/images/pro_02defer.png"),
  require("@/assets/images/pro_02defer_ok.png"),
  require("@/assets/images/pro_01transfer_un.png"),
  require("@/assets/images/pro_02check.png"),
  require("@/assets/images/pro_02defer_ok.png"),
  require("@/assets/images/pro_01transfer_un.png"),
  require("@/assets/images/pro_update.png"),
  require("@/assets/images/pro_stop.png"),
  require("@/assets/images/pro_01transfer_un.png"),
];

export default {
  props: ["processData"],
  watch: {
    processData(e) {
      if (e && e.length > 0) {
        let arr = [];
        e.forEach((item) => {
          let index = item.event - 1;
          if (index > 13 || index < 0) {
            console.log("数据有误,超出下标");
            return;
          }
          if (item.notes == null) {
            item.notes = "";
          }
          let obj = {
            username: item.dealperson,
            datetime: this.dateFormat(item.dealtime, "YYYY-MM-DD HH:mm"),
            title: titles[index],
            src: imgs[index],
            color: colors[index],
            event: item.event,
            notes: item.notes ? item.notes.split("；") : null,
          };
          arr.push(obj);
        });

        this.processList = arr;
      }
    },
  },
  data() {
    return {
      processList: [
        // {
        //    title: "隐患上报",
        //    src: require('@/assets/images/pro_01report.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#72BEFF',
        // },
        // {
        //    title: "移交",
        //    src: require('@/assets/images/pro_01transfer.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#5ADC9C',
        // },
        // {
        //    title: "移交申请拒绝",
        //    src: require('@/assets/images/pro_01transfer_un.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#FF7977',
        // },
        // {
        //    title: "移交",
        //    src: require('@/assets/images/pro_01transfer.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#5ADC9C',
        // },
        // {
        //    title: "移交申请同意",
        //    src: require('@/assets/images/pro_01transfer_ok.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#72BEFF',
        // },
        // {
        //    title: "分配",
        //    src: require('@/assets/images/pro_02distribute.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#5ADC9C',
        // },
        // {
        //    title: "申请延期",
        //    src: require('@/assets/images/pro_02defer.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#FFD75C',
        // },
        // {
        //    title: "延期拒绝",
        //    src: require('@/assets/images/pro_01transfer_un.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#FF7977',
        // },
        // {
        //    title: "申请延期",
        //    src: require('@/assets/images/pro_02defer.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#FFD75C',
        // },
        // {
        //    title: "延期同意",
        //    src: require('@/assets/images/pro_02defer_ok.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#5ADC9C',
        // },
        // {
        //    title: "提交验收",
        //    src: require('@/assets/images/pro_02check.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#72BEFF',
        // },
        // {
        //    title: "验收拒绝",
        //    src: require('@/assets/images/pro_01transfer_un.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#FF7977',
        // },
        // {
        //    title: "",
        //    src: require('@/assets/images/pro_02check.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#72BEFF',
        // },
        // {
        //    title: "验收同意",
        //    src: require('@/assets/images/pro_02defer_ok.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#5ADC9C',
        // },
        // {
        //    title: "就地整改",
        //    src: require('@/assets/images/pro_update.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#FFD75C',
        // },
        // {
        //    title: "停业停产整顿",
        //    src: require('@/assets/images/pro_stop.png'),
        //    datetime: "1990-01-01 10:00",
        //    username: "孙尚香",
        //    color: '#FF7977',
        // }
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.right-process-modify {
  width: 340px !important;
  .item-modify {
    text-align: left;
    padding-left: 20px;
    padding-right: 20px;
    height: 150px !important;
    background-color: #fff;
  }
  .title-modify {
    height: 60px;
    line-height: 60px;
    user-select: none;
    a {
      display: inline-block;
      height: 28px;
      line-height: 28px;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      color: #fff;
      background-color: rgba(114, 190, 255, 1);
      border-radius: 4px;
      min-width: 60px;
      text-align: center;
      position: relative;
      z-index: 1;
    }
  }
  .content-modify {
    display: flex;
    align-items: center;
    .icon-modify {
      width: 60px;
      height: 60px;
      position: relative;
      z-index: 1;
    }
    .text-modify {
      flex: 1;
      height: 65px;
      margin-left: 20px;
      padding-left: 10px;
      border: 1px solid rgba(197, 208, 215, 1);
      border-radius: 4px;
      .datetime-modify {
        font-size: 12px;
        color: #33618f;
        height: 30px;
        line-height: 30px;
      }
      .username-modify {
        font-size: 14px;
        color: #33618f;
        height: 35px;
        line-height: 35px;
      }
    }
  }

  .item-container-modify {
    position: relative;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 50px;
      top: 20px;
      bottom: 0;
      width: 2px;
      background: rgba(114, 190, 255, 1);
      box-shadow: 0px 3px 6px rgba(51, 97, 143, 1);
      opacity: 0.2;
    }
  }
}
</style>


